/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import 'core-js/stable';
import { createRoot } from 'react-dom/client';
import App from './App';
import React from 'react';

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import {
  modes as defaultModes,
  extensions as defaultExtensions,
  productProfile,
} from '@product/plugins';
import loadDynamicConfig from './loadDynamicConfig';
export { history } from './utils/history';
export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';

if (productProfile === 'clinical') {
  const url = new URL(window.location.href);
  ['configUrl', 'customization', 'mode', 'share'].forEach(key => url.searchParams.delete(key));
  if (!url.pathname.endsWith('/clinical/launch')) url.searchParams.delete('token');
  window.history.replaceState(window.history.state, '', url.pathname + url.search);
  const meta = document.createElement('meta');
  meta.name = 'referrer';
  meta.content = 'no-referrer';
  document.head.appendChild(meta);
}

(productProfile === 'patient' ? loadDynamicConfig(window.config) : Promise.resolve(null)).then(
  config_json => {
    // Reset Dynamic config if defined
    if (config_json !== null) {
      window.config = config_json;
    }

    /**
     * Combine our appConfiguration with installed extensions and modes.
     * In the future appConfiguration may contain modes added at runtime.
     *  */
    const appProps = {
      config: window ? window.config : {},
      defaultExtensions,
      defaultModes,
    };

    const container = document.getElementById('root');

    const root = createRoot(container);
    root.render(React.createElement(App, appProps));
  }
);
